import { makeAutoObservable } from 'mobx'

export class Addon {
  id
  title
  subtitle
  price
  vat
  spots_left
  participants = []

  /**
   * @param {{
   *   id?: number,
   *   title?: string,
   *   subtitle?: string,
   *   price?: number,
   *   vat?: number,
   *   spots_left?: number,
   *   ga4_tracking_item?: object
   * }} obj
   */
  constructor({id, title, subtitle, price, vat, spots_left, ga4_tracking_item= {}} = {}) {
    makeAutoObservable(this)
    this.id = id
    this.title = title
    this.subtitle = subtitle
    this.price = price
    this.vat = vat
    this.spots_left = spots_left
    this.ga4_tracking_item = ga4_tracking_item
  }

  get totalDiscount() {
    return this.participants.reduce((acc, participant) => {
      return acc + participant.totalDiscount
    }, 0)
  }

  get mailDiscount() {
    return this.participants.reduce((acc, participant) => {
      return acc + participant.newsletterDiscount
    }, 0)
  }

  get couponDiscount() {
    return this.participants.reduce((acc, participant) => {
      return acc + participant.couponDiscount
    }, 0)
  }

  get loyaltyDiscount() {
    return this.participants.reduce((acc, participant) => {
      return acc + participant.loyaltyDiscount
    }, 0)
  }

  get totalPriceExDiscount() {
    return this.price * Math.max(this.participants.length, 1)
  }

  get totalPrice() {
    return this.roundToTwoDecimals(this.totalPriceExDiscount - this.totalDiscount)
  }

  get totalVat() {
    let vat = this.vat

    if (this.participants.length > 0) {
      vat = this.participants.reduce((acc, participant) => {
        return acc + participant.vat
      }, 0)
    }

    return this.roundToTwoDecimals(vat)
  }

  roundToTwoDecimals(number) {
    return +(Math.round(+(number + 'e+2')) + 'e-2') // https://www.delftstack.com/howto/javascript/javascript-round-to-2-decimal-places/#using-the-custom-function-to-round-a-number-to2-decimal-places-in-javascript
  }

  addParticipant(participant) {
    this.participants.push(participant)
  }

  removeParticipant(participant) {
    this.participants.splice(this.participants.indexOf(participant), 1)
  }

  updateContent (value) {
    if(!value) {
      return
    }

    this.title = value.data?.title ?? this.title
    this.subtitle = value.data?.subtitle ?? this.subtitle
    this.pricePerParticipant = value.data?.total_price ?? this.pricePerParticipant
    this.vatPerParticipant = value.data?.total_price_vat ?? this.vatPerParticipant
    this.spots_left = value.data?.spots_left ?? this.spots_left
    this.featured_image = value.data?.featured_image ?? this.featured_image

    this.participants.forEach(participant => {
      participant.updateContent(value)
    })
  }
}
